import React, { useState, useEffect } from "react";
import { Row, Col, Table, Container, Badge } from "reactstrap";
import ApiCaller from "../../../../api/apiCaller";
import PolygonCommentModal from '../../components/PolygonCommentModal';

import "./index.css";

export default function PlanningList() {
  const [planningZones, setPlanningZones] = useState([]);

  const [isShowCommentPopup, setIsShowCommentPopup] = useState(false);
  const [selectedPlanningZone, setSelectedPlanningZone] = useState({});

  const [cityOptions, setCityOptions] = useState<Array<any>>([]);

  const search = window.location.search;
  const searchParams = new URLSearchParams(search);
  const mapBoundaryRaw = searchParams.get('mapBoundary') || '{}';
  const [mapBoundary, setMapBoundary] = useState<any>(JSON.parse(mapBoundaryRaw) || {});
  
  const tooglePlanningZoneCommentModal = (selectedPlanningZone?:any) => {
    setIsShowCommentPopup(!isShowCommentPopup);
    if (selectedPlanningZone) {
      const transformedSelectedPlanningZone = {
        ...selectedPlanningZone,
        properties: selectedPlanningZone,
      };
      setSelectedPlanningZone(transformedSelectedPlanningZone);
    }
  }
  
  const getCityListing = async () => {
    let options = [
      {
        label: "Tất cả",
        value: "all",
      },
    ];
    const res = await ApiCaller.get(`city/`);
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        options.push({
          value: item?.id,
          label: item?.name,
        });
      });
      setCityOptions(options);
    }
  };

  const getPlanningZones = async () => {
    const res = await ApiCaller.post(
      'site_planning_selection_area/list?limit=10000',
      mapBoundary,
    );
    if (res?.result) {
      setPlanningZones(res.result);
    }  
  }

  useEffect(() => {
    getCityListing();
  }, []);

  useEffect(() => {
    getPlanningZones();
  }, [mapBoundary]);

  return (
    <Container>
      {/* <Col xs={6} sm={4}>
        <Label>Tỉnh / Thành phố</Label>
        <Select
          isMulti
          options={cityOptions}
        />
      </Col> */}
      <Row>
        <Col xs={12}>
          <Table responsive>
            <thead>
              <th>Tên</th>
              <th>Mô tả</th>
              <th>Tạo bởi</th>
              <th>Ngày tạo</th>
              <th>Nhận xét</th>
            </thead>
            <tbody>
              {planningZones.map((planningZone:any) =>
                <tr key={planningZone.id}>
                  <td>{planningZone.title}</td>
                  <td style={styles.descriptionCell}>{planningZone.description}</td>
                  <td>{`${planningZone.user.first_name} ${planningZone.user.last_name}`}</td>
                  <td style={styles.descriptionCell}>{planningZone.created_on_formatted}</td>
                  <td>
                    <div
                      onClick={() => tooglePlanningZoneCommentModal(planningZone)}
                      style={styles.commentControl}
                    >
                      <span style={styles.commentText}>Nhận xét</span>
                      {planningZone.site_planning_zone_comment_count > 0 &&
                        <Badge color="primary">
                          {planningZone.site_planning_zone_comment_count}
                        </Badge>
                      }
                    </div>
                  </td>
                </tr>  
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
      {isShowCommentPopup &&
        <PolygonCommentModal
          initialIsOpen={isShowCommentPopup}
          planningPolygonToShowComment={selectedPlanningZone}
          onCancelled={() => tooglePlanningZoneCommentModal()}
        />
      }
    </Container>
  )
}

const styles = {
  descriptionCell: {
    whiteSpace: 'pre-wrap',
  } as React.CSSProperties,
  commentControl: {
    dislay: 'flex',
    alignItems: 'center',
  } as React.CSSProperties,
  commentText: {
    color: 'var(--primary)',
    marginRight: 6,
    cursor: 'pointer',
  },
};
